import { Listing } from "components/Listing"
import { AttributeCombination } from "pages/AttributeCombination"
import AttributeValuesPrices from "pages/AttributeValuesPrices"
import CalculationRules from "pages/CalculationRules"
import { CostCollector } from "pages/CostCollector"
import { Detail } from "pages/Detail"
import { Economic } from "pages/Economic"
import PricesRecalculate from "pages/PricesRecalculate"
import SetNomenclaturePrices from "pages/SetNomenclaturePrices"
import Staller from "pages/Staller"
import { CreateRouteData } from "./tools"

export const economicRoutes: CreateRouteData[] = [
    {
        path: "region",
        title: "Регионы",
        render: () => <Listing />,
        createAndUpdate: () => <Detail />,
        permission: "economics",
    },
    {
        path: "currency",
        title: "Валюты",
        render: () => <Listing />,
        createAndUpdate: () => <Detail />,
        permission: "economics",
    },
    {
        path: "price-type",
        title: "Типы цен",
        render: () => <Listing />,
        createAndUpdate: () => <Detail />,
        permission: "economics",
    },
    {
        path: "series",
        title: "Серии",
        render: () => <Listing noCreate />,
        update: () => <Economic.Series />,
        permission: "economics",
    },
    {
        path: "producer",
        title: "Поставщики",
        render: () => <Listing noCreate />,
        update: () => <Economic.Producer />,
        permission: "economics",
    },
    {
        path: "price-nomenclature-filter",
        title: "Фильтры номенклатуры",
        render: () => <Listing />,
        createAndUpdate: () => <Economic.NomenclatureFilters />,
        permission: "economics",
    },
    {
        path: "price-margin-preset",
        title: "Типы наценок",
        render: () => <Listing />,
        createAndUpdate: () => <Detail />,
        permission: "economics",
    },
    {
        path: "price-calculation-rule",
        title: "Правила расчёта",
        render: () => <Listing />,
        createAndUpdate: () => <CalculationRules />,
        permission: "economics",
    },
    {
        path: "cost-collector",
        title: "Сборщик цены от поставщика",
        render: () => <CostCollector />,
        permission: "economics",
    },
    {
        path: "prices-recalculate",
        title: "Пересчёт цен",
        render: () => <PricesRecalculate />,
        permission: "economics",
    },
    {
        path: "attribute-values-prices",
        title: "Сочетания значений",
        render: () => <AttributeValuesPrices />,
        permission: "economics",
    },
    {
        render: () => <Listing />,
        path: "attribute-combination",
        title: "Справочник сочетаний",
        createAndUpdate: () => <AttributeCombination />,
        permission: "economics",
    },
    {
        path: "model-value-staller",
        render: () => <Staller />,
        title: "Настройки Сталлер",
        permission: "economics",
    },
    {
        path: "set-nomenclature-prices",
        title: "Ручная установка цен",
        render: () => <SetNomenclaturePrices />,
        permission: "economics",
    },
]
